import { render } from "./IconPlusSmall.vue?vue&type=template&id=6b1b6f7e"
import script from "./IconPlusSmall.vue?vue&type=script&lang=js"
export * from "./IconPlusSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__